module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"candidateNotPassed":"The candidate has not completed","onlineInterview":"online interview","sendInvitation":"Send invitation by e-mail"}}')
  delete Component.options._Ctor
}
